import React, { useEffect, useState } from "react";
import { Col, Form, Row, Table, Image, Modal, Button } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import Media from "react-media";

import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";

import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import moment from "moment";
import {
  SwipeableList,
  SwipeableListItem,
} from "@sandstreamdev/react-swipeable-list";

import Alert from "react-s-alert";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";

import SVG from "react-inlinesvg";
import { PopupActionButton } from "../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import SlidingComponent from "../../../reusableComponents/slidingToggleComponent/SlidingComponent";
import BasicPagination from "../../../Pagination/Pagination";
import { NewInputText } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import {
  admin_role_management_get_all,
  admin_edit_role,
  admin_delete_role,
} from "../../../../store/actions/SuperAdminActions/superAdminRolesAction";

const data = [
  {
    type: "Admin",
    users: 2,
    desc: "sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad",
    actions: true,
  },
];

const SuperAdminRoleManagement = (props) => {
  //state
  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const [state, setState] = useState({
    search: "",
  });
  const [show, setShow] = useState(false);
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const [roles, setrolesData] = useState([]);
  const onSearchChange = (e) => {
    let tempdata = props.rolesData.adminRoles.filter((items) =>
      items.role_name.toLowerCase().includes(e.target.value.toLowerCase())
    );
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
    if (e.target.value) {
      setrolesData(tempdata);
    } else {
      setrolesData(props.rolesData.adminRoles);
    }
  };

  useEffect(() => {
    setrolesData(props.rolesData.adminRoles);
  }, [props.rolesData.adminRoles]);

  const filterData = (filter, closeModel) => {
    let tempdata = [];
    if (filter === 1) {
      tempdata = props.rolesData.adminRoles.filter(
        (items) => items.active === true
      );
      setrolesData(tempdata);
    } else if (filter === 2) {
      tempdata = props.rolesData.adminRoles.filter(
        (items) => items.active === false
      );
      setrolesData(tempdata);
    } else {
      setrolesData(props.rolesData.adminRoles);
    }
    closeModel();
  };

  const getData = () => {
    const token = props.auth.user.accessToken;
    props.admin_role_management_get_all(token);
  };

  useEffect(() => {
    getData();
  }, []);

  const editRoleFun = (data, setErrors, handleCloseEditRole) => {
    if (!data.role_name) {
      setErrors({ role_name: "Please enter a role name" });
    } else if (!data.role_desc) {
      setErrors({ role_desc: "Please enter a role description." });
    } else if (!("roleRemove" in data)) {
      setErrors({ roleRemove: "Please select an option." });
    } else {
      const token = props.auth.user.accessToken;
      const formData = {
        _id: data._id,
        role_name: data.role_name,
        description: data.role_desc,
        isDefaultRole: data.role_default ? true : false,
        isRemovable: data.roleRemove,
      };
      props.admin_edit_role(token, formData, () => {
        Alert.success(`<h4>Role edited successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        handleCloseEditRole();
        getData();
      });
    }
  };

  const deleteRole = (id, handleClose) => {
    const token = props.auth.user.accessToken;

    props.admin_delete_role(token, id, () => {
      Alert.success(`<h4>Role deleted successfully</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
      handleClose();
      getData();
    });
  };

  const changeStatus = (_id, statuschecked) => {
    const token = props.auth.user.accessToken;
    const formData = {
      _id: _id,
      active: statuschecked,
    };
    props.admin_edit_role(token, formData, () => {
      Alert.success(`<h4>Role status changed  successfully</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
      getData();
    });
  };
  const renderRoleManagementAccordian = () => {
    return roles.map((data, index) => (
      // index >= (currentPagination - 1) * totalRecordsInOnePage &&
      // index < currentPagination * totalRecordsInOnePage &&
      <React.Fragment>
        <SwipeableList className={`swipeOffer`}>
          {({ swipeOffer, ...rest }) => (
            <div className={`${show ? "swipeOffer" : ""}`}>
              <SwipeableListItem
                swipeLeft={{
                  content: (
                    <div className="d-flex swipeOption">
                      <button
                        type="button"
                        className="n_button_d_status font_18_m "
                        style={{ backgroundColor: "white" }}
                      >
                        {" "}
                        <ViewModel data={data} />
                      </button>

                      <button
                        type="button"
                        className="n_button_d_status font_18_m popup-cancel-button"
                      >
                        <EditModel data={data} editRoleFun={editRoleFun} />
                      </button>
                      {data.isRemovable && (
                        <DeleteModal
                          redButton={true}
                          name="Role"
                          onClick={(handleCloseBlockUser) =>
                            deleteRole(data._id, handleCloseBlockUser)
                          }
                        />
                      )}
                    </div>
                  ),
                  action: () => setShow(true),
                }}
                swipeRight={{
                  // content: <div>Revealed content during swipe</div>,
                  action: () => setShow(false),
                }}
                {...rest}
              >
                <Card className="main-reusable-accordion">
                  <Accordion.Toggle as={Card.Header} eventKey={index + 1}>
                    <div className="d-flex align-items-center">
                      <div className="card-header-left f10-500">
                        {" "}
                        {data.role_name}
                      </div>
                      <div
                        className="card-header-middle f10-500"
                        style={{ width: "17%" }}
                      >
                        0
                      </div>
                      <div
                        className="card-header-right f10-500"
                        style={{ width: "47%", textAlign: "left" }}
                      >
                        {data.description}
                      </div>
                    </div>
                  </Accordion.Toggle>
                </Card>
              </SwipeableListItem>
            </div>
          )}
        </SwipeableList>
      </React.Fragment>
    ));
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row superadmin-pending-chains-vendor">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel container-fluid">
            <HomeReusableTopBarNavigation />

            <React.Fragment>
              <Media query="(min-width: 992px)">
                <div className="d-flex justify-content-between align-items-center pt-4 pb-4 ">
                  <div className="f24_700_HelveticaNeue">Role Management</div>
                  <NavLink
                    to="/superadmin-add-role"
                    className="btn btn-danger btn2 btn-lg"
                  >
                    + Add Role
                  </NavLink>
                </div>
              </Media>
              <Row className="align-items-center">
                {/* <Col className="col-auto seating-topbar-search">
                  <div className="filter-button">
                    <Filter filterData={filterData} />
                  </div>
                </Col> */}
                <Col xs={8} md={4}>
                  <div className="filter-button-search">
                    <Paper component="form" className="enSearch2 d-flex">
                      <IconButton type="submit" aria-label="search">
                        <SearchIcon />
                      </IconButton>
                      <InputBase
                        placeholder="Search"
                        name="search"
                        inputProps={{
                          "aria-label": "Search by Name or Phone Number",
                        }}
                        onChange={onSearchChange}
                        value={state.search}
                      />
                    </Paper>
                  </div>
                </Col>
              </Row>
              <Media query="(max-width: 991px)">
                <>
                  <div className="row seating-dashboard-table">
                    <div className="col-4 mpr-1">
                      <p className="f12-700 pl-3">Role Type</p>
                    </div>
                    <div className="col-2 mpl-1 mpr-1">
                      <p className="f12-700">Users</p>
                    </div>
                    <div className="col-6 mpl-1">
                      <p className="f12-700">Role Description</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 p-0">
                      <Accordion>{renderRoleManagementAccordian()}</Accordion>
                    </div>
                  </div>
                </>
              </Media>
              <Media query="(min-width: 991px)">
                <div className="user-table-reusable-superadmin table-responsive">
                  <Table>
                    <thead>
                      <tr className="super_admin_all_users_table_head">
                        <th style={{ width: "15%" }} className="f12-700">
                          Role Type
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Users
                        </th>
                        <th style={{ width: "40%" }} className="f12-700">
                          Role Description
                        </th>
                        <th style={{ width: "20%" }} className="f12-700">
                          Status
                        </th>
                        <th style={{ width: "15%" }} className="f12-700">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {roles.map((data, index) => {
                        return (
                          <tr
                            key={index}
                            className="super_admin_all_users_table_body"
                            style={{ wordBreak: "break-word" }}
                          >
                            <td colSpan="7" className="p-0 w-100">
                              <table className="w-100 HideShowTable enMinWidth900">
                                <tbody>
                                  <tr>
                                    <td style={{ width: "15%" }}>
                                      <div className="f14-500">
                                        {data.role_name}
                                      </div>
                                    </td>
                                    <td style={{ width: "10%" }}>
                                      <div className="f14-500">0</div>
                                    </td>
                                    <td style={{ width: "40%" }}>
                                      <div className="f12-400">
                                        {data.description}
                                      </div>
                                    </td>
                                    <td style={{ width: "20%" }}>
                                      <div className="d-flex ">
                                        <div className="f10-500 mr-3">
                                          {data.active ? "Active" : "Inactive"}
                                        </div>
                                        <SlidingComponent
                                          name="status"
                                          checked={data.active}
                                          currentState={data.active}
                                          type={"checkbox"}
                                          toggleclass={
                                            "toggle vendor-super-admin-toggle d-flex align-items-center mb-2"
                                          }
                                          toggleinputclass={
                                            "toggle__switch vendor-super-admin-toggle"
                                          }
                                          onChange={() => {
                                            changeStatus(
                                              data._id,
                                              !data.active
                                            );
                                          }}
                                          // slidingonClick={this.onSelecttogglestatusChange(data)}
                                          // defaultChecked={true}
                                        />
                                      </div>
                                    </td>
                                    <td style={{ width: "15%" }}>
                                      <div className="d-flex">
                                        <ViewModel data={data} />
                                        <EditModel
                                          data={data}
                                          editRoleFun={editRoleFun}
                                        />
                                        {data.isRemovable && (
                                          <DeleteModal
                                            redButton={true}
                                            name="Role"
                                            onClick={(handleCloseBlockUser) =>
                                              deleteRole(
                                                data._id,
                                                handleCloseBlockUser
                                              )
                                            }
                                          />
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </Media>
              <BasicPagination
                totalRecords={50}
                limit={5}
                batch={page}
                onBatchChange={(e) => handleBatchChange(e)}
              />
            </React.Fragment>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const ViewModel = (props) => {
  const [ShowViewRole, setShowViewRole] = useState(false);
  const handleShowViewRole = () => setShowViewRole(!ShowViewRole);

  return (
    <>
      <div className="enIconBtn mr-3" onClick={handleShowViewRole}>
        <Image
          src={require("../../../../assets/images/UserManagement/eye.svg")}
          alt="Edit"
          title="Edit"
          fluid
        />
      </div>
      <Modal show={ShowViewRole} onHide={handleShowViewRole} centered size="md">
        <Modal.Header className="px-4 border-0" closeButton>
          <div>
            <Modal.Title className="f20-700 pb-2">
              View Roles Privileges
            </Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body className="px-4">
          <div className="f14-400">Role Type</div>
          <div className="f16-700">{props.data.role_name}</div>
          <div className="f14-400 mt-4">Role Short Description</div>
          <div className="f16-700">{props.data.description}</div>
          <div className="f14-400 mt-4">No. of users</div>
          <div className="f16-700">
            {/* <Image
              src={require("../../../../assets/images/UserManagement/pencil.svg")}
              alt="Edit"
              title="Edit"
              fluid
            />
            Sophia Peter */}
            -
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const Filter = (props) => {
  const [open, setOpen] = useState(false);
  const [state, setState] = useState(0);
  const onOpenModal = () => setOpen(true);
  const onCloseModel = () => setOpen(false);
  return (
    <>
      <div
        onClick={onOpenModal}
        className="d-flex align-items-center justify-content-between cursor"
      >
        <Image
          alt="filter"
          title="filter"
          width="20px"
          src={require("../../../../assets/images/ActionImages/image/filter.svg")}
        />
        <div className="f12-500 text-blue mx-2">Filter</div>
        <i className="fa fa-angle-down text-blue" aria-hidden="true"></i>
      </div>
      <Modal show={open} onHide={onCloseModel} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title>Filter</Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Select one relevant option from below
          <div className="row mt-4">
            <div className="col-6 col-md-4 mb-4">
              <div
                className={`status-selected-button-box f16-500 ${
                  state === 0 && `sts_sld_btn_box_a`
                }`}
                type="button"
                onClick={() => {
                  setState(0);
                }}
              >
                <div class="row justify-content-center">
                  <div class="">All</div>
                </div>
              </div>
            </div>
            <div class="col-6 col-md-4 mb-4">
              <div
                className={`status-selected-button-box f16-500 ${
                  state === 1 && `sts_sld_btn_box_a`
                }`}
                type="button"
                onClick={() => {
                  setState(1);
                }}
              >
                <div class="row justify-content-center">
                  <div class="">Active</div>
                </div>
              </div>
            </div>
            <div class="col-6 col-md-4 mb-4">
              <div
                className={`status-selected-button-box f16-500 ${
                  state === 2 && `sts_sld_btn_box_a`
                }`}
                type="button"
                onClick={() => {
                  setState(2);
                }}
              >
                <div class="row justify-content-center">
                  <div class="">Inactive</div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-md mr-4 px-5"
            onClick={() => {
              setState(0);
              props.filterData(1, onCloseModel);
            }}
          >
            Reset Filter
          </Button>
          <Button
            variant="danger"
            className="btn-md px-5"
            onClick={() => {
              props.filterData(state, onCloseModel);
            }}
          >
            Apply Filter
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const DeleteModal = (props) => {
  const [showBlockUser, seShowBlockUser] = useState(false);
  const handleCloseBlockUser = () => seShowBlockUser(false);
  const handleShowBlockUser = () => seShowBlockUser(true);
  return (
    <React.Fragment>
      {props.redButton ? (
        <div className="enIconBtn mr-3" onClick={handleShowBlockUser}>
          <Image
            src={require("../../../../assets/images/UserManagement/Delete.svg")}
            alt="Delete"
            title="Delete"
            fluid
          />
        </div>
      ) : (
        <button
          type="button"
          className="enBtnoutlineGrayIcon"
          onClick={handleShowBlockUser}
        >
          <SVG
            src={require("../../../../assets/images/UserManagement/Delete.svg")}
          />
        </button>
      )}
      <Modal show={showBlockUser} onHide={handleCloseBlockUser} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Are you sure to Delete the {props.name} ?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={handleCloseBlockUser}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={() => {
              handleCloseBlockUser();
              props.onClick(handleCloseBlockUser);
            }}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

const EditModel = (props) => {
  const [showEditRole, setShowEditRole] = useState(false);
  const handleShowEditRole = () => setShowEditRole(true);
  const handleCloseEditRole = () => setShowEditRole(false);
  const [data, setData] = useState({ roleRemove: false });
  useEffect(() => {
    setData({
      _id: props.data._id,
      role_name: props.data.role_name,
      role_desc: props.data.description,
      role_default: props.data.isDefaultRole,
      roleRemove: props.data.isRemovable,
    });
  }, [props.data]);

  const [errors, setErrors] = useState({});
  const onChange = (e) => {
    setErrors({});
    setData({ ...data, [e.target.name]: e.target.value });
  };
  const editRoleFun = (e) => {
    e.preventDefault();
    props.editRoleFun(data, setErrors, handleCloseEditRole);
  };
  return (
    <>
      <div className="enIconBtn mr-3" onClick={handleShowEditRole}>
        <Image
          src={require("../../../../assets/images/UserManagement/pencil.svg")}
          alt="Edit"
          title="Edit"
          fluid
        />
      </div>
      <Modal
        show={showEditRole}
        onHide={handleCloseEditRole}
        centered
        size="lg"
      >
        <Modal.Header className="px-4 border-0" closeButton>
          <div>
            <Modal.Title className="f20-700 pb-2">Edit Role</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body className="px-4">
          <>
            <Form className="row">
              <Col lg="6">
                <NewInputText
                  labelText="Role Name"
                  extraClass="mb-4 w-100"
                  name="role_name"
                  value={data.role_name}
                  onChange={onChange}
                  errorTrue={errors.role_name}
                />
                <div className="mb-2" style={{ color: "red" }}>
                  {errors.role_name}
                </div>
                <NewInputText
                  labelText="Role Description"
                  extraClass="mb-3 w-100"
                  multiline={true}
                  rows="5"
                  name="role_desc"
                  value={data.role_desc}
                  onChange={onChange}
                  errorTrue={errors.role_desc}
                />
                <div className="mb-2" style={{ color: "red" }}>
                  {errors.role_desc}
                </div>
                <div className="d-flex align-items-center pb-5">
                  <Form.Check
                    label="1"
                    inline
                    className="enCheckBoxOnly"
                    name="role_default"
                    checked={data.role_default}
                    onChange={() => {
                      setData({
                        ...data,
                        role_default: !data.role_default,
                      });
                    }}
                    errorTrue={errors.role_default}
                  />
                  <div className="f12-500">Set As Default Role</div>
                </div>
                <div className="f14-700 mb-4">Role Removable?</div>
                <div className="checkbox-bank-account justify-content-start">
                  <label className="enRadioWithText small mr-3">
                    <span className="f14-500">Yes</span>
                    <input
                      type="radio"
                      name="roleRemove"
                      checked={data.roleRemove}
                      onChange={() => {
                        setData({ ...data, roleRemove: true });
                      }}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <label className="enRadioWithText small f18-500">
                    <span className="f14-500">No</span>
                    <input
                      type="radio"
                      name="roleRemove"
                      checked={!data.roleRemove}
                      onChange={() => {
                        setData({ ...data, roleRemove: false });
                      }}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                <div className="mb-2" style={{ color: "red" }}>
                  {errors.roleRemove}
                </div>
                <div className="d-flex align-items-center py-4">
                  <Button
                    variant="outline-secondary"
                    className="btn150px btn-lg mr-4 px-5"
                    onClick={handleCloseEditRole}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="danger"
                    onClick={(e) => {
                      // setState(true);
                      editRoleFun(e);
                    }}
                    className="btn150px btn-lg px-5"
                  >
                    Save
                  </Button>
                </div>
              </Col>
            </Form>
          </>
        </Modal.Body>
      </Modal>
    </>
  );
};
SuperAdminRoleManagement.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  rolesData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  rolesData: state.superAdminRoles,
});

export default connect(mapStateToProps, {
  admin_role_management_get_all,
  admin_edit_role,
  admin_delete_role,
})(withRouter(SuperAdminRoleManagement));
